var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6157 21.8627C16.9219 21.8627 21.2235 17.5611 21.2235 12.2548C21.2235 6.94855 16.9219 2.64697 11.6157 2.64697C6.30939 2.64697 2.00781 6.94855 2.00781 12.2548C2.00781 13.978 2.46144 15.5952 3.25579 16.9935L2.00781 21.8627L7.02782 20.6986C8.39111 21.4409 9.95413 21.8627 11.6157 21.8627ZM11.6157 20.3845C16.1056 20.3845 19.7454 16.7447 19.7454 12.2548C19.7454 7.7649 16.1056 4.1251 11.6157 4.1251C7.12574 4.1251 3.48594 7.7649 3.48594 12.2548C3.48594 13.9884 4.02855 15.5952 4.95319 16.9148L4.22501 19.6455L7.00384 18.9508C8.31424 19.855 9.90311 20.3845 11.6157 20.3845Z",
    fill: "#BFC8D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8534 11.5688C19.8534 16.117 16.1663 19.8041 11.6181 19.8041C9.88332 19.8041 8.27381 19.2677 6.9464 18.3517L4.13148 19.0554L4.86912 16.2893C3.93247 14.9526 3.38281 13.3249 3.38281 11.5688C3.38281 7.02056 7.06988 3.3335 11.6181 3.3335C16.1663 3.3335 19.8534 7.02056 19.8534 11.5688Z",
    fill: "url(#paint0_linear_53_33226)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6157 21.1766C16.9219 21.1766 21.2235 16.875 21.2235 11.5688C21.2235 6.26252 16.9219 1.96094 11.6157 1.96094C6.30939 1.96094 2.00781 6.26252 2.00781 11.5688C2.00781 13.2919 2.46144 14.9091 3.25579 16.3075L2.00781 21.1766L7.02782 20.0126C8.39111 20.7549 9.95413 21.1766 11.6157 21.1766ZM11.6157 19.6985C16.1056 19.6985 19.7454 16.0587 19.7454 11.5688C19.7454 7.07886 16.1056 3.43907 11.6157 3.43907C7.12574 3.43907 3.48594 7.07886 3.48594 11.5688C3.48594 13.3024 4.02855 14.9092 4.95319 16.2287L4.22501 18.9594L7.00384 18.2647C8.31424 19.169 9.90311 19.6985 11.6157 19.6985Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21616 7.10809C8.98772 6.64926 8.63729 6.68988 8.28328 6.68988C7.65059 6.68988 6.66406 7.44772 6.66406 8.85814C6.66406 10.014 7.17341 11.2794 8.88977 13.1722C10.5462 14.9989 12.7226 15.9438 14.5294 15.9117C16.3363 15.8795 16.708 14.3246 16.708 13.7996C16.708 13.5668 16.5636 13.4507 16.4641 13.4192C15.8484 13.1237 14.7127 12.5731 14.4544 12.4696C14.196 12.3662 14.0611 12.5061 13.9772 12.5822C13.7429 12.8055 13.2784 13.4636 13.1193 13.6116C12.9603 13.7596 12.7232 13.6847 12.6245 13.6288C12.2614 13.4831 11.277 13.0452 10.4923 12.2845C9.52176 11.3437 9.4648 11.02 9.28196 10.7319C9.13569 10.5014 9.24302 10.36 9.29658 10.2982C9.50568 10.0569 9.7944 9.68444 9.92388 9.49933C10.0534 9.31422 9.95057 9.03318 9.8889 8.85814C9.62364 8.10533 9.39891 7.47515 9.21616 7.10809Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_53_33226",
    x1: 18.824,
    y1: 5.39232,
    x2: 3.38281,
    y2: 19.8041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BD066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27B43E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.682872eee02c48b4f2b080dd5400dc1f.svg";
export { ForwardRef as ReactComponent };